var _excluded = ["typography", "emphasis", "arrowType", "arrowColor", "arrowDirection", "isExpanded", "to", "href", "title", "openInNewTab", "onClick", "onMouseEnter", "onMouseLeave", "rel", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useState } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var ArrowLongBigSvg = function ArrowLongBigSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m12 3-1.586 1.586 6.277 6.289H3v2.25h13.691l-6.277 6.289L12 21l9-9-9-9z"
  }));
};
ArrowLongBigSvg.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowLongSvg = function ArrowLongSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 2 6.942 3.058l4.185 4.192H2v1.5h9.127l-4.185 4.193L8 14l6-6-6-6z"
  }));
};
ArrowLongSvg.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowShortSvg = function ArrowShortSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.718 5.674 1.64 9.72a.968.968 0 0 1-1.36 0 .95.95 0 0 1 0-1.349L3.68 5 .282 1.628a.95.95 0 0 1 0-1.349.968.968 0 0 1 1.36 0L5.72 4.325a.95.95 0 0 1 0 1.349z"
  }));
};
ArrowShortSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "10"
};
import getBorderColor from "../../../utils/getBorderColor";
import getColor from "../../../utils/getColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import Link from "../../quarks/Link";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
export var defaultProps = {
  typography: "small2",
  emphasis: "medium",
  arrowType: "short",
  arrowColor: "primary",
  arrowDirection: "right"
};
var arrowGutterSpace = 1;
var arrowLeftRotate = "rotate(180deg)";
var arrowDownRotate = "rotate(90deg)";
var arrowUpRotate = "rotate(270deg)";
var arrowHorizontalTranslateSpace = 0.5;
var arrowVerticalTranslateSpace = 2;
export var StyledArrowLinkAtm = styled(Link).withConfig({
  componentId: "sc-15g6rzr-0"
})(function (_ref) {
  var _ref$$typography = _ref.$typography,
    $typography = _ref$$typography === void 0 ? defaultProps.typography : _ref$$typography,
    _ref$$emphasis = _ref.$emphasis,
    $emphasis = _ref$$emphasis === void 0 ? defaultProps.emphasis : _ref$$emphasis,
    $isExpanded = _ref.$isExpanded,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["", ";", ";display:inline-flex;align-items:center;text-align:center;text-decoration:none;cursor:pointer;", " &:hover{color:", ";}"], cssTextAtm({
    typography: $typography,
    onColor: $onColor,
    emphasis: $emphasis
  }), transition("color"), $isExpanded && css(["justify-content:space-between;width:100%;"]), getTextColor(theme, $onColor, $emphasis, "hover"));
});
var baseArrowStyles = function baseArrowStyles($arrowColor, $arrowDirection, $hasHover, $onColor) {
  return css(["", ";flex-shrink:0;margin-left:", ";align-self:center;fill:", ";", " ", " ", " ", ""], transition("transform"), space(arrowGutterSpace), function (props) {
    return $arrowColor === "default" ? getBorderColor(props.theme, $onColor, "high") : getColor(props.theme, $arrowColor);
  }, $arrowDirection === "left" && css(["order:-1;margin-right:", ";margin-left:0;transform:", ";"], space(arrowGutterSpace), arrowLeftRotate), $arrowDirection === "down" && css(["transform:", ";"], arrowDownRotate), $arrowDirection === "up" && css(["transform:", ";"], arrowUpRotate), $hasHover && css(["", " ", " ", " ", ""], $arrowDirection === "right" && css(["transform:translateX(", ");"], space(arrowHorizontalTranslateSpace)), $arrowDirection === "left" && css(["transform:translateX(", ") ", ";"], space(-1 * arrowHorizontalTranslateSpace), arrowLeftRotate), $arrowDirection === "down" && css(["transform:translateY(", ") ", ";"], unit(arrowVerticalTranslateSpace), arrowDownRotate), $arrowDirection === "up" && css(["transform:translateY(", ") ", ";"], unit(-1 * arrowVerticalTranslateSpace), arrowUpRotate)));
};
export var ArrowShort = styled(ArrowShortSvg).withConfig({
  componentId: "sc-15g6rzr-1"
})(function (_ref2) {
  var $arrowColor = _ref2.$arrowColor,
    $arrowDirection = _ref2.$arrowDirection,
    $hasHover = _ref2.$hasHover,
    $onColor = _ref2.$onColor;
  return css(["", ";"], baseArrowStyles($arrowColor, $arrowDirection, $hasHover, $onColor));
});
var ArrowLong = styled(ArrowLongSvg).withConfig({
  componentId: "sc-15g6rzr-2"
})(function (_ref3) {
  var $arrowColor = _ref3.$arrowColor,
    $arrowDirection = _ref3.$arrowDirection,
    $hasHover = _ref3.$hasHover,
    $onColor = _ref3.$onColor;
  return css(["", ";"], baseArrowStyles($arrowColor, $arrowDirection, $hasHover, $onColor));
});
var ArrowLongBig = styled(ArrowLongBigSvg).withConfig({
  componentId: "sc-15g6rzr-3"
})(function (_ref4) {
  var $arrowColor = _ref4.$arrowColor,
    $arrowDirection = _ref4.$arrowDirection,
    $hasHover = _ref4.$hasHover,
    $onColor = _ref4.$onColor;
  return css(["", ";"], baseArrowStyles($arrowColor, $arrowDirection, $hasHover, $onColor));
});
function ArrowLinkAtm(_ref5) {
  var _ref5$typography = _ref5.typography,
    typography = _ref5$typography === void 0 ? defaultProps.typography : _ref5$typography,
    _ref5$emphasis = _ref5.emphasis,
    emphasis = _ref5$emphasis === void 0 ? defaultProps.emphasis : _ref5$emphasis,
    _ref5$arrowType = _ref5.arrowType,
    arrowType = _ref5$arrowType === void 0 ? defaultProps.arrowType : _ref5$arrowType,
    _ref5$arrowColor = _ref5.arrowColor,
    arrowColor = _ref5$arrowColor === void 0 ? defaultProps.arrowColor : _ref5$arrowColor,
    _ref5$arrowDirection = _ref5.arrowDirection,
    arrowDirection = _ref5$arrowDirection === void 0 ? defaultProps.arrowDirection : _ref5$arrowDirection,
    isExpanded = _ref5.isExpanded,
    to = _ref5.to,
    href = _ref5.href,
    title = _ref5.title,
    openInNewTab = _ref5.openInNewTab,
    onClick = _ref5.onClick,
    onMouseEnter = _ref5.onMouseEnter,
    onMouseLeave = _ref5.onMouseLeave,
    rel = _ref5.rel,
    children = _ref5.children,
    restProps = _objectWithoutProperties(_ref5, _excluded);
  var onColor = useContext(OnColorContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var arrowCommonProps = {
    $arrowColor: arrowColor,
    $arrowDirection: arrowDirection,
    $hasHover: hover,
    $onColor: onColor
  };
  var handleOnMouseEnter = function handleOnMouseEnter(event) {
    setHover(true);
    if (onMouseEnter) {
      onMouseEnter(event);
    }
  };
  var handleOnMouseLeave = function handleOnMouseLeave(event) {
    setHover(false);
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  };
  var arrowJsx;
  if (arrowType === "short") {
    arrowJsx = /*#__PURE__*/React.createElement(ArrowShort, arrowCommonProps);
  } else if (arrowType === "long") {
    arrowJsx = /*#__PURE__*/React.createElement(ArrowLong, arrowCommonProps);
  } else {
    arrowJsx = /*#__PURE__*/React.createElement(ArrowLongBig, arrowCommonProps);
  }
  return /*#__PURE__*/React.createElement(StyledArrowLinkAtm, _extends({
    to: to,
    href: href,
    title: title,
    openInNewTab: openInNewTab,
    onClick: onClick,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave,
    rel: rel,
    $typography: typography,
    $emphasis: emphasis,
    $isExpanded: isExpanded,
    $onColor: onColor
  }, restProps), children, arrowJsx);
}
export default ArrowLinkAtm;